// extracted by mini-css-extract-plugin
module.exports = {"badge":"AdminActionsNav_badge__bL5ZR","selected":"AdminActionsNav_selected__rWzxQ"};